export default function changeLog(properties, original, updated) {
  return properties.filter(x => updated[x] !== original[x]);
}
